<script setup lang="ts">
  import { ref } from 'vue';

  const showMore = ref<boolean>(false);

  defineProps<{
    shortDescription: string;
    longDescription: string;
  }>();
</script>
<template>
  <p v-if="showMore" v-html="longDescription"></p>
  <p v-else v-html="shortDescription"></p>
  <a
    v-if="shortDescription !== longDescription"
    class="link underline margin-top"
    @click="showMore = !showMore"
  >
    {{ showMore ? 'Toon minder' : 'Toon meer' }}
  </a>
</template>
